import { render, staticRenderFns } from "./Comprobaciones.vue?vue&type=template&id=583884d0&"
import script from "./Comprobaciones.vue?vue&type=script&lang=js&"
export * from "./Comprobaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports